<template>
  <div class="preview-nav-btn" :class="positionClass">
    <v-btn
      class="preview-nav-btn__btn"
      :icon="icon"
      variant="flat"
      color="black"
      :loading="loading"
      :aria-label="ariaLabel"
      @click="$emit('click')"
    />
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  direction: {
    type: String as PropType<'prev' | 'next'>,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['click'])

const { t } = useI18n()

const icon = computed(() =>
  props.direction === 'prev' ? 'far fa-chevron-left' : 'far fa-chevron-right',
)

const positionClass = computed(() =>
  props.direction === 'prev'
    ? 'preview-nav-btn--prev'
    : 'preview-nav-btn--next',
)

const ariaLabel = computed(() =>
  props.direction === 'prev'
    ? t('preview.previous_attachment')
    : t('preview.next_attachment'),
)
</script>

<style scoped lang="css">
.preview-nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}

.preview-nav-btn--prev {
  left: 16px;
}

.preview-nav-btn--next {
  right: 16px;
}

.preview-nav-btn__btn {
  opacity: 0.4;
  transition: opacity 0.2s ease;
}

.preview-nav-btn__btn:hover {
  opacity: 0.9;
}
</style>
